import { Tooltip } from '@material-ui/core';
import { Domain } from '@material-ui/icons';
import { MouseEvent } from 'react';
import { ShipperProfileLink } from 'shared/modules/shipper/ShipperProfileLink';
import { PostingShipperDTO } from '../../data/dto/PostingLoadDTO';
import { PostingDescription } from './PostingDescription';
import { PostingShipperInfoTooltip } from './PostingShipperInfoTooltip';

interface ShipperCompanyNameProps {
  shipper: PostingShipperDTO;
  disableLink?: boolean;
}

export function ShipperCompanyName({
  shipper,
  disableLink,
}: ShipperCompanyNameProps) {
  return (
    <PostingDescription
      icon={
        <Domain
          aria-label="Shipper company name icon"
          fontSize="small"
          color="action"
        />
      }
    >
      {disableLink ? (
        shipper.name
      ) : (
        <Tooltip title={<PostingShipperInfoTooltip shipper={shipper} />}>
          <ShipperProfileLink
            noWrap={true}
            variant="body2"
            guid={shipper.guid}
            color="primary"
            medium="Load List"
            onClick={(event: MouseEvent) => {
              event.stopPropagation();
            }}
          >
            {shipper.name}
          </ShipperProfileLink>
        </Tooltip>
      )}
    </PostingDescription>
  );
}
